module.exports = __webpack_public_path__ + "static/media/multi-platform-moduleD2.c88b9ba9.png";